
import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import mixpanel from "mixpanel-browser";


import App from "./App";
import "./index.css";
import "./utils/i18n";
import initMixpanel from "./utils/mixpanel"
import {ThemeProvider} from "../src/pages/contexts/ThemeContext";



const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();


// ✅ Initialize Mixpanel with ad-blocker bypass (no Django conflicts)
console.log("🚀 Initializing Mixpanel with ad-blocker bypass...")
initMixpanel()

root.render(
    <BrowserRouter>
        <QueryClientProvider client={queryClient}>
            <ThemeProvider>
                <Routes>
                    <Route path="/*" element={<App/>}/>
                </Routes>
            </ThemeProvider>
        </QueryClientProvider>

    </BrowserRouter>
);
